import { createSlice } from "@reduxjs/toolkit";

// createing reducer with intial value
export const studentReducer = createSlice({
  name: "student_store",
  initialState: {
    isAuthenticated: false,
    queue: {},
    dashboard: {
      nav_trace: "",
    },
  },
  reducers: {
    startStudentAction: (state, action) => {
      return {
        ...state,
        queue: action.payload,
        isAuthenticated: true,
        dashboard: {
          nav_trace: "",
        },
      };
    },
    dispathcDashboardNavigator: (state, action) => {
      const { item } = action.payload;
      return {
        ...state,
        dashboard: {
          nav_trace: item,
        },
      };
    },

    updateSignatureUrl: (state, action) => {
      const { signature } = action.payload;
      try {
        // ensure structure exists
        if (!state.queue) state.queue = {};
        if (!state.queue.studentData) state.queue.studentData = {};
        if (!state.queue.studentData.personalInfo)
          state.queue.studentData.personalInfo = {};

        // update value
        state.queue.studentData.personalInfo.signature = signature;
      } catch (error) {
        console.error("Error updating signature URL:", error);
      }
    },
    logOut: (state, action) => {
      return {
        ...state,
        queue: [],
        isAuthenticated: false,
      };
    },
  },
});

export const {
  startStudentAction,
  logOut,
  dispathcDashboardNavigator,
  updatePassportUrl,
  updateSignatureUrl,
} = studentReducer.actions;

export default studentReducer.reducer;
